// extracted by mini-css-extract-plugin
export default {"nested":"ProfileMenuDrawer_nested__YEm4J","menu-list":"ProfileMenuDrawer_menu-list__oubeq","menu-footer":"ProfileMenuDrawer_menu-footer__RqJZx"};